import type { GetHashtags200PageAllOf } from './getHashtags200PageAllOf';
import type { GetHashtags200PageAllOfThree } from './getHashtags200PageAllOfThree';

export type GetHashtags200Page = GetHashtags200PageAllOf & GetHashtags200PageAllOfThree;
